export default __webpack_public_path__ + "static/media/cvod-18.3bebdf6b.svg";